(function ($) {

    $.fn.modal = function () {

        var elem     = $(this),
            triggers = elem.find('.js-modal__trigger');

        var init = function () {

            triggers.off('click.modal').on('click.modal', function (event) {

                var trigger = $(this),
                    target  = $(trigger.attr('href'));

                // Empty jQuery object — target not in DOM
                if (!target.length) { return; }

                event.preventDefault();

                $('#modal_login input[name="access_redirect"]').val(trigger.data('access_redirect'));

                if (target.hasClass('is-active')) {
                    modalClose(target);
                } else {
                    modalOpen(target);
                }

            });

            $('body').on('click.modal', '.modal__background:not(.modal__container)', function () {

                var target = $(this).parent();

                if (target.hasClass('is-active')) {
                    modalClose(target);
                }

            });

        };

        var modalOpen = function (target) {

            // POSITION IS THE STYLESHEET'S JOB NOW, NOT THIS FUNCTION'S.
            //
            // This used to do `target.css('top', $(window).scrollTop())`, which
            // dragged a document-anchored modal down to wherever the reader was.
            // The modal moved inside `.site-head` on 2026-09-21 and is anchored to
            // the header with `top: 100%`, so that INLINE top would beat the rule
            // and undo the anchor — the panel would jump back to the top of the
            // document the moment anyone opened it below the fold.
            //
            // `disablescroll` still does the real work of making an absolutely
            // positioned panel read as pinned while it is open.
            target.fadeIn(300, function () {

                target.addClass('is-active');
                $(window).disablescroll({ handleKeys: false });

            });

        };

        var modalClose = function (target) {

            target.fadeOut(300, function () {

                target.removeClass('is-active');
                $(window).disablescroll('undo');

            });

        };

        init();

        return {
            init:      init,
            modalOpen: modalOpen
        };

    };

}(jQuery));
